import { Grid, Typography } from '@material-ui/core'
import styled from 'styled-components'

import CaliforniaProp65WarningImport from '../../summary/CaliforniaProp65Warning'
import { OrderSummary } from '../../summary/OrderSummary'
import OrderSection from '../OrderSection'

export const MobileOrderSummary = styled(OrderSummary)`
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  border: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
  border-radius: 0 0 4px 4px;
  max-width: unset;
  padding-top: 15px;

  @media (min-width: 960px) {
    display: none;
  }
`

export const Heading = styled(Grid)`
  border-top: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
  padding-top: 20px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: center;

  @media (min-width: 600px) {
    padding-left: 0;
    border-left: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
    border-right: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
`

export const ThankYou = styled(Grid)`
  border-top: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
  padding: 25px 15px;
  text-align: center;

  @media (min-width: 600px) {
    border-left: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
    border-right: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
  }
`

export const AllowDelay = styled(Typography)`
  margin-top: 1em;
`

export const MobileCaliforniaProp65Warning = styled(CaliforniaProp65WarningImport)`
  border-top: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
  margin-bottom: 0;
  margin-top: 0;
  padding: 25px 15px 8px;
  & a {
    color: ${({ theme }) => theme.colors.grayscale.black};
  }

  @media (min-width: 600px) {
    border: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
    border-bottom: none;
  }
  @media (min-width: 960px) {
    display: none;
  }
`

export const OrderDateSection = styled(OrderSection)`
  border-bottom: none;
  border-top: none;
`
